import { FeedObjectFocusName } from "class/Feed";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Focus } from "class/Focus";
import { State } from "store/types";

import { setReportSettings as SetReportSettings } from "store/article/report/reducers";
import { ReportSettings } from "store/ui/report/setup/types";

export function useReportSettings(): [ReportSettings, (settings: Partial<ReportSettings>) => void] {
	const dispatch = useDispatch();
	const reportSettings = useSelector((state: State) => state.article.report.configuration.definition.settings);
	const setReportSettings = useCallback((settings: any) => {
		dispatch(SetReportSettings(settings));
	}, [dispatch]);

	return [
		reportSettings,
		setReportSettings
	];
}

export function useFeedFinder(feedIds: string[]): FeedObjectFocusName[] {
	const focusList = useSelector((state: any) => state.focus.list.focusList);
	const feeds = useMemo(() =>
		feedIds.map((feedId: string) => Focus.findFeedInFocusList(feedId, focusList || [])).filter(feed => feed !== null) as FeedObjectFocusName[]
	, [feedIds, focusList]);

	return feeds;
}
